import React, { useEffect, useState } from 'react';
import {
  CreateProps,
  FormTab,
  SaveButton,
  TabbedForm,
  Toolbar,
  useDataProvider,
  useNotify,
  useRedirect,
  useRefresh,
  Notification,
  Edit,
  useEditController,
} from 'react-admin';
import DreamHomeGeneral from './GeneralDreamHome';
import { useSelector, useDispatch } from 'react-redux';
import { Raffle } from '../../types/raffle';
import { TicketRatesDiscount } from '../../types/property';
import DreamHomeDescription from './DescriptionDreamHome';
import DiscountAndTickets from '../common/discount/DiscountTickets';
import {
  checkCreditsDateError,
  checkDateError,
  checkDiscount,
  checkDiscountFill,
  checkGeneralError,
  checkPreviousValue,
  checkTourLink,
} from '../../helpers/checkDreamHome';
import { Button } from '@material-ui/core';
import { checkFillDiscount, checkIsCash } from '../../helpers/checkDiscount';
import { GeneralTabErrors } from '../../types/tabsError';
import DocumentTitle from '../common/documentTitle/DocumentTitle';
import { CreditProps } from '../common/generalPickersBlocks/credits/CreditsPickerComponent';
import {
  compilePropertyRequest,
  CompileRaffleRequest,
} from '../../helpers/compileDreamHome';
import {
  checkFreeTicketsError,
  checkTicketsBundlesError,
} from '../../helpers/checkfFreeTickets';
import {
  setFreeTickets,
  setTicketsBundles,
} from '../../redux/actions/propertyActions';
import { OverviewProvider } from './shared/overview/OverviewContext';
import { Overview } from './shared/overview/OverviewBlock';
import { checkIsOverviewPropRowValid } from './shared/overview/PropertyRow';

const CustomToolbar = (
  props,
  handleImagesError,
  discountFillError,
  generalForm,
  setGeneralError,
  setIsDiscountValidate,
  overview,
  setOverviewError,
  creditsData: {
    creditsArr: Array<CreditProps>;
    dateType: string;
    creditsStatus: boolean;
    creditsStartDate: Date | string | undefined;
    creditsEndDate: Date | string | undefined;
  }
): JSX.Element => {
  const [disabledSaveButton, setDisabledSaveButton] = useState(false);
  const cancel = () => {
    window.location.href = '/';
  };
  const location = props.location.pathname.split('/');
  const path = location[location.length - 1] === '1' ? '2' : '1';
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();
  const stateApp = useSelector((state) => state);
  const dataProvider = useDataProvider();
  const dispatch = useDispatch();

  const handleSave = async (data): Promise<void> => {
    console.log('data: ', data);
    generalForm.adressFill = stateApp.property.adress;
    generalForm.imagesFill = stateApp.property.galleryFiles;
    generalForm.emailGalleryImage = stateApp.property.emailGalleryImage;
    const { generalResult, generalResultError } =
      checkGeneralError(generalForm);
    if (generalResultError) {
      notify('The form in not valid. Please check for errors', 'error');
      setGeneralError(generalResult);
      return;
    }
    // if (!checkIsOverviewPropRowValid(overview)) {
    //   setOverviewError(true);
    //   notify("The form is not valid. Please check for errors", "error");
    //   return;
    // }

    if (path === '2') {
      redirect(`/dreamHome/${props.id}/2`);
      return;
    }
    if (!data.ticketPrice || !data.defaultTickets) {
      setIsDiscountValidate(true);
      notify('The form in not valid. Please check for errors', 'error');
      return;
    }
    if (!data.stepperCountrdown) {
      console.log('Dream Home without stepper');
      data.stepperCountdown = {
        isActive: false,
        title: '',
        startAt: '',
        endsAt: '',
      };
    }
    data.property.longitude = stateApp.property.longitude;
    data.property.latitude = stateApp.property.latitude;
    data.property.filesGallery = stateApp.property.galleryFiles;
    data.property.filesGalleryMobile = stateApp.property.galleryFilesMobile;
    data.discountRates = data.isDiscountRates
      ? stateApp.property.discountRates
      : Array<TicketRatesDiscount>();
    data.discountTicket = data.isActiveDiscount
      ? stateApp.property.ticketDiscount
      : { percent: 1, newPrice: 1 };
    data.startAt = generalForm.startDateFill;
    data.endsAt = generalForm.endDateFill;
    data.stepperCountdown.isActive = generalForm.stepperIsActive;
    data.stepperCountdown.title = generalForm.stepperTitle;
    data.stepperCountdown.startAt = generalForm.stepperStartDateFill
      ? generalForm.stepperStartDateFill
      : new Date();
    data.stepperCountdown.endsAt = generalForm.stepperEndDateFill
      ? generalForm.stepperEndDateFill
      : new Date();
    data.endsAt = generalForm.endDateFill;
    data.creditsRates = creditsData.creditsArr;
    data.creditsEndDate = creditsData.creditsEndDate;
    data.creditsStartDate = creditsData.creditsStartDate;
    data.isCreditsActive = creditsData.creditsStatus;
    data.isCreditsPermanent = creditsData.dateType === 'allDate' ? true : false;
    data.freeTicketsRates = stateApp.property.freeTickets.freeTicketsRates;
    data.isFreeTicketsRates = stateApp.property.freeTickets.isActive;
    data.ticketsBundles = stateApp.property.ticketsBounds.bundleTickets;
    if (!data.property.filesGallery.length) {
      handleImagesError(true);
      notify('The form is not valid. Please check for errors', 'error');
      return;
    }
    if (stateApp.property.adress) {
      data.property.location = stateApp.property.adress;
    }
    // if (!data.property.location) {
    //   notify('The form is not valid. Please check for errors', 'error');
    //   return;
    // }
    const discountFill = checkDiscountFill(data);
    const previousTicketCount = checkPreviousValue(data);

    if (discountFill) {
      discountFillError(true);
    }
    const checkError = checkDiscount(data);
    const checkDiscountTickets = checkFillDiscount(
      data.isActiveDiscount,
      data.discountTicket
    );
    const checkDate = checkDateError(data);
    const checkCreditsDate = data.isCreditsPermanent
      ? false
      : checkCreditsDateError(data);
    const freeTicketsError = checkFreeTicketsError(data.freeTicketsRates);
    const ticketsBundlesError = checkTicketsBundlesError(data.ticketsBundles);

    if (
      !checkError ||
      checkDate ||
      discountFill ||
      !previousTicketCount ||
      checkCreditsDate ||
      checkDiscountTickets ||
      freeTicketsError ||
      ticketsBundlesError
    ) {
      notify('The form is not valid. Please check for errors', 'error');
      return;
    }

    data.property.tourLink = checkTourLink(data.property.tourLink);
    const reverseDiscount = checkIsCash(
      data.discountCategory,
      data.discountRates
    );
    const requestProperty = compilePropertyRequest(data.property, overview);
    setDisabledSaveButton(true);
    let response = stateApp.property.isNew
      ? await dataProvider.createProperty(
          requestProperty.property,
          requestProperty.images
        )
      : await dataProvider.updateProperty(
          requestProperty.property,
          requestProperty.images
        );
    const requestRaffle = CompileRaffleRequest(
      data,
      response.id,
      reverseDiscount
    );
    dispatch(
      setFreeTickets({
        isActive: requestRaffle.isFreeTicketsRates,
        freeTicketsRates: requestRaffle.freeTicketsRates,
      })
    );
    try {
      let result = stateApp.property.isNew
        ? await dataProvider.create('raffles', {
            data: requestRaffle,
          })
        : await dataProvider.update('raffles', {
            data: requestRaffle,
            id: props.id,
            previousData: {} as any,
          });
      if (result.data.id) {
        await dataProvider.updateMostPopular({
          competitionType: 'DREAMHOME',
          id: result.data._id,
          title: result.data.title,
        });
        if (result.data.isTrending && result.data.active) {
          await dataProvider.addFeatured('DREAMHOME', result.data._id);
        } else {
          await dataProvider.removeFeatured('DREAMHOME', result.data._id);
        }
        const action = stateApp.property.isNew ? 'created' : 'updated';
        notify(`Dream home ${action}`);
        refresh();
        redirect('/dreamHome');
      } else {
        notify(result.data.message, 'error');
      }
    } catch (error: any) {
      setDisabledSaveButton(false);
      notify(error, 'error');
    }
  };
  const toNextTab = () => {
    generalForm.adressFill = stateApp.property.adress;
    generalForm.imagesFill = stateApp.property.galleryFiles;
    generalForm.emailGalleryImage = stateApp.property.emailGalleryImage;
    const { generalResult, generalResultError } =
      checkGeneralError(generalForm);

    if (generalResultError) {
      notify('The form in not valid. Please check for errors', 'error');
      setGeneralError(generalResult);
      return;
    }

    // if (path === '2') {
    //   if (!checkIsOverviewPropRowValid(overview)) {
    //     setOverviewError(true);
    //     notify('The form is not valid. Please check for errors', 'error');
    //     return;
    //   }
    // }
    redirect(`/dreamHome/${props.id}/${path}`);
  };
  return (
    <Toolbar {...props} className='buttons-wrapper'>
      {location[location.length - 1] === '2' ? (
        <SaveButton
          className='save-button'
          disabled={disabledSaveButton}
          onSave={handleSave}
        />
      ) : (
        <Button className='cancel-button' onClick={toNextTab}>
          Save
        </Button>
      )}
      <Button onClick={cancel} className='cancel-button'>
        Cancel
      </Button>
    </Toolbar>
  );
};

interface State {
  adress: string;
  isCash: boolean;
  isPercent: boolean;
  isEditedAddress: boolean;
}

const EditDreamHome: React.FC<CreateProps> = (props) => {
  const controllerProps = useEditController<Raffle>(props);
  const ticketsBundles = useSelector(
    (state) => state.property.ticketsBounds.bundleTickets
  );
  const dispatch = useDispatch();
  const [state, setState] = useState<State>({
    adress: '',
    isCash: false,
    isPercent: false,
    isEditedAddress: false,
  });

  const [errors, setError] = useState({
    imagesError: false,
    emailGalleryImageError: false,
    discountFillError: false,
  });

  const [generalError, setGeneralError] = useState<GeneralTabErrors>({
    imagesError: false,
    titleError: false,
    adressError: false,
    startDateError: false,
    endDateError: false,
  });

  const [generalForm, setGeneralForm] = useState({
    titleFill: '',
    startDateFill: '',
    endDateFill: '',
    stepperIsActive: false,
    stepperStartDateFill: '',
    stepperEndDateFill: '',
    stepperTitle: '',
    title: '',
    bundleTitle: '',
  });

  const [isDiscountValidate, setIsDiscountValidate] = useState(false);
  const [datesValue, setDatesValue] = useState<{
    startDateValue: Date | string;
    endDateValue: Date | string;
  }>({
    startDateValue: new Date(),
    endDateValue: new Date('2031-01-18T19:55:00.000+00:00'),
  });
  const [creditDateType, setCreditDateType] = useState<string>('allDate');

  const handleChangeCreditsDateType = (e: any) => {
    setCreditDateType(e.currentTarget.value);
  };
  const [overview, setOverview] = useState<Array<Overview>>([]);

  const [overviewError, setOverviewError] = useState(false);

  const [stateCredits, setCredits] = useState<Array<CreditProps>>([
    {
      id: '1',
      count: 20,
      percent: 30,
    },
  ]);

  useEffect(() => {
    if (controllerProps.record) {
      if (controllerProps.record.creditsRates)
        setCredits(controllerProps.record.creditsRates);
      setDoesCreditsActive(controllerProps.record.isCreditsActive);
      setDatesValue({
        startDateValue:
          (controllerProps.record.creditsStartDate &&
            new Date(controllerProps.record.creditsStartDate)) ||
          new Date(),
        endDateValue:
          (controllerProps.record.creditsEndDate &&
            new Date(controllerProps.record.creditsEndDate)) ||
          new Date('2031-01-18T19:55:00.000+00:00'),
      });
      if (
        controllerProps.record.property &&
        controllerProps.record.property.overview
      ) {
        setOverview(controllerProps.record.property.overview);
      }
      if (controllerProps.record.ticketsBundles) {
        dispatch(
          setTicketsBundles({
            bundleTickets: controllerProps.record.ticketsBundles,
          })
        );
      }
      if (controllerProps.record.isCreditsPermanent) {
        setCreditDateType('allDate');
      } else {
        setCreditDateType('date');
      }
    }
  }, [controllerProps.record]);

  useEffect(() => {
    console.log(generalForm);
  }, [generalForm]);

  const [isActiveCredits, setDoesCreditsActive] = useState<boolean>(false);

  const handleChangeCreditsStatus = () => {
    setDoesCreditsActive(!isActiveCredits);
  };

  const handleSetCredits = (creditsArr: Array<CreditProps>) => {
    setCredits(creditsArr);
  };

  const handleSetDateValue = (value: string, dateName: string) => {
    setDatesValue({
      ...datesValue,
      [dateName]: value,
    });
  };

  const fillGeneralForm = (name: string, value: string) => {
    setGeneralForm({ ...generalForm, [name]: value });
  };

  const fillGeneralFormEdit = (
    titleFill: string,
    startDateFill: string,
    endDateFill: string,
    stepperIsActive: boolean,
    stepperStartDateFill: string,
    stepperEndDateFill: string,
    stepperTitle: string,
    title: string,
    bundleTitle: string
  ) => {
    setGeneralForm({
      titleFill: titleFill,
      startDateFill: startDateFill,
      endDateFill: endDateFill,
      stepperIsActive: stepperIsActive || false,
      stepperStartDateFill: stepperStartDateFill || '',
      stepperEndDateFill: stepperEndDateFill || '',
      stepperTitle: stepperTitle || '',
      title,
      bundleTitle: bundleTitle || '',
    });
  };

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setState({ ...state, [event.currentTarget.name]: checked });
  };

  const handleImagesError = (error: boolean) => {
    setError({ ...errors, imagesError: error });
  };

  const handleDiscountFillError = (error: boolean) => {
    setError({ ...errors, discountFillError: error });
  };

  const setPercent = () => {
    setState({ ...state, isPercent: false });
  };

  const setCash = () => {
    setState({ ...state, isCash: false });
  };

  const setAddress = (adress: string) => {
    setState({ ...state, adress: adress, isEditedAddress: true });
  };
  return (
    <>
      <DocumentTitle
        core='Prize'
        secondary='Dream Home'
        purpose='Edit'
        appointment='dream home'
      />
      <Edit {...props} hasShow={false}>
        <TabbedForm
          toolbar={CustomToolbar(
            props,
            handleImagesError,
            handleDiscountFillError,
            generalForm,
            setGeneralError,
            setIsDiscountValidate,
            overview,
            setOverviewError,
            {
              creditsArr: stateCredits,
              dateType: creditDateType,
              creditsStartDate: datesValue.startDateValue,
              creditsEndDate: datesValue.endDateValue,
              creditsStatus: isActiveCredits,
            }
          )}
          className='general-tab'
        >
          <FormTab label='General'>
            <DreamHomeGeneral
              imagesError={errors.imagesError}
              emailGalleryImageError={errors.emailGalleryImageError}
              adress={
                state.isEditedAddress
                  ? state.adress
                  : controllerProps.record?.property.location || ''
              }
              record={controllerProps.record}
              isShow={false}
              setAddress={setAddress}
              latitude={
                controllerProps.record?.property.latitude
                  ? controllerProps.record?.property.latitude
                  : 0
              }
              longitude={
                controllerProps.record?.property.longitude
                  ? controllerProps.record?.property.longitude
                  : 0
              }
              fillGeneralForm={fillGeneralForm}
              fillGeneralFormEdit={fillGeneralFormEdit}
              generalError={generalError}
            />
          </FormTab>
          <FormTab label='Description'>
            <OverviewProvider prizeType='dreamhome'>
              <DreamHomeDescription
                key={generalForm.title}
                title={generalForm.title}
                record={controllerProps.record}
                properties={overview}
                setProperties={setOverview}
                setAddress={setAddress}
                isShow={false}
                overviewError={overviewError}
              />
            </OverviewProvider>
          </FormTab>
          <FormTab label='Discount & Tickets'>
            <DiscountAndTickets
              ticketPrice={
                controllerProps.record?.ticketPrice
                  ? controllerProps.record?.ticketPrice
                  : 0
              }
              entity={controllerProps.record}
              isShow={false}
              isCash={state.isCash}
              isPercent={state.isPercent}
              handleChange={handleChange}
              removePercent={setPercent}
              removeCash={setCash}
              discountSource='discountCategory'
              discountFillError={errors.discountFillError}
              isOdds={false}
              isValidate={isDiscountValidate}
              handleChangeCreditsStatus={handleChangeCreditsStatus}
              handleChangeCreditsDateType={handleChangeCreditsDateType}
              handleSetCredits={handleSetCredits}
              isActiveCredits={isActiveCredits}
              credits={stateCredits}
              handleSetDateValue={handleSetDateValue}
              creditDateType={creditDateType}
              creditsStartDateValue={datesValue.startDateValue}
              creditsEndDateValue={datesValue.endDateValue}
              competition='raffle'
              freeTicketsRates={controllerProps.record?.freeTicketsRates}
              isFreeTicketsActive={controllerProps.record?.isFreeTicketsRates}
              ticketsBounds={ticketsBundles}
            />
          </FormTab>
          <Notification />
        </TabbedForm>
      </Edit>
    </>
  );
};

export default EditDreamHome;
